import { Box } from "@mui/system";
import styles from "./bulkActionMenu.module.scss";
import Button from "../buttons/Buttons";
import i18next from "i18next";
import PropTypes from "prop-types";

const BulkActionMenu = (props) => {
  const { btnlist, handleCloseButtonClick, selectionModel = [] } = props;

  return (
    <Box data-testid="bulkaction">
      <Box className={styles.bulkActionMenuWrapper}>
        <Box className={styles.menuItemWrapper}>
          <Box className={styles.menuContentWrapper}>
            <Box className={styles.buttonWrapper}>
              {btnlist?.map(
                ({
                  title,
                  buttonType,
                  withIcon,
                  handleClick,
                  iconStyle,
                  customStyle,
                }) => {
                  return (
                    <Button
                      key={title}
                      title={i18next.t(title)}
                      iconStyle={styles[iconStyle]}
                      buttonType={buttonType}
                      withIcon={withIcon}
                      handleClick={() => handleClick()}
                      classList={customStyle}
                    />
                  );
                }
              )}
            </Box>

            <Box className={styles.menuRightSection}>
              <Box className={styles.Content}>
                <Box className={styles.count}>{selectionModel.length}</Box>
                <span className={styles.Text}>
                  {i18next.t("items selected")}
                </span>
              </Box>

              <Box className={styles.IconCrossWrapper}>
                <Box
                  className={styles.IconCross}
                  onClick={handleCloseButtonClick}
                  onKeyDown={() => {}}
                ></Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BulkActionMenu;
BulkActionMenu.propTypes = {
  btnlist: PropTypes.any,
  handleCloseButtonClick: PropTypes.any,
  selectionModel: PropTypes.any,
};
